import { j as x } from "./jsx-runtime-944c88e2.js";
import { Box as c } from "@chakra-ui/react";
import "react";
const A = ({
  firstname: o,
  lastname: r,
  bgColor: p = "#F0F0F5",
  borderColor: t = "#F0F0F5",
  textColor: u = "#000000",
  size: i = "60px",
  fontSize: b = "xl",
  fontWeight: d = 300,
  lineHeight: s = "124%",
  textMargin: F = "17px",
  carrier: g,
  overrideText: h
}) => {
  const j = g === "cht_home" ? r == null ? void 0 : r.substring(0, 2) : (o == null ? void 0 : o.substring(0, 1)) + "" + (r == null ? void 0 : r.substring(0, 1));
  return /* @__PURE__ */ x.jsx(
    c,
    {
      className: "myasurion-avatar-initials",
      borderRadius: i,
      w: i,
      h: i,
      textAlign: "center",
      border: `1px solid ${t}`,
      bg: p,
      color: u,
      fontSize: b,
      fontWeight: d,
      lineHeight: s,
      children: /* @__PURE__ */ x.jsx(c, { my: F, mx: 0, children: h ?? j })
    }
  );
};
export {
  A as AvatarInitials
};
